function AuthForm({
  mode,
  loading,
  error,
  formData,
  onModeChange,
  onFieldChange,
  onSubmit
}) {
  const tabBaseClasses =
    'rounded-lg px-3 py-2 text-sm font-semibold transition disabled:cursor-not-allowed disabled:opacity-60';
  const tabActiveClasses = 'bg-maroon-700 text-white';
  const tabInactiveClasses = 'bg-maroon-100 text-maroon-800 hover:bg-maroon-200';

  return (
    <div className="p-5 md:p-7">
      <h1 className="mb-2 text-2xl md:text-3xl font-bold text-maroon-900">Kanaiya POS</h1>
      <p className="mb-5 text-sm text-maroon-700">Use your Kanaiya account to continue.</p>

      <div className="mb-4 grid grid-cols-2 gap-2">
        <button
          type="button"
          className={`${tabBaseClasses} ${mode === 'login' ? tabActiveClasses : tabInactiveClasses}`}
          onClick={() => onModeChange('login')}
          disabled={loading}
        >
          Login
        </button>
        <button
          type="button"
          className={`${tabBaseClasses} ${mode === 'register' ? tabActiveClasses : tabInactiveClasses}`}
          onClick={() => onModeChange('register')}
          disabled={loading}
        >
          Register
        </button>
      </div>

      <form onSubmit={onSubmit} className="flex flex-col gap-2.5">
        {mode === 'register' ? (
          <>
            <label htmlFor="name" className="text-sm font-medium text-maroon-900">
              Name
            </label>
            <input
              id="name"
              type="text"
              value={formData.name}
              onChange={(event) => onFieldChange('name', event.target.value)}
              className="rounded-lg border border-maroon-200 bg-white px-3 py-2 text-sm outline-none ring-maroon-300 focus:ring-2"
              required
            />
          </>
        ) : null}

        <label htmlFor="email" className="text-sm font-medium text-maroon-900">
          Email
        </label>
        <input
          id="email"
          type="email"
          value={formData.email}
          onChange={(event) => onFieldChange('email', event.target.value)}
          className="rounded-lg border border-maroon-200 bg-white px-3 py-2 text-sm outline-none ring-maroon-300 focus:ring-2"
          required
        />

        <label htmlFor="password" className="text-sm font-medium text-maroon-900">
          Password
        </label>
        <input
          id="password"
          type="password"
          value={formData.password}
          onChange={(event) => onFieldChange('password', event.target.value)}
          className="rounded-lg border border-maroon-200 bg-white px-3 py-2 text-sm outline-none ring-maroon-300 focus:ring-2"
          required
        />

        {mode === 'register' ? (
          <>
            <label htmlFor="password_confirmation" className="text-sm font-medium text-maroon-900">
              Confirm Password
            </label>
            <input
              id="password_confirmation"
              type="password"
              value={formData.confirmPassword}
              onChange={(event) => onFieldChange('confirmPassword', event.target.value)}
              className="rounded-lg border border-maroon-200 bg-white px-3 py-2 text-sm outline-none ring-maroon-300 focus:ring-2"
              required
            />
          </>
        ) : null}

        {error ? <div className="text-sm font-medium text-red-600">{error}</div> : null}

        <button
          type="submit"
          disabled={loading}
          className="mt-1 rounded-lg bg-maroon-700 px-3 py-2 text-sm font-semibold text-white transition hover:bg-maroon-800 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {loading ? 'Please wait...' : mode === 'login' ? 'Login' : 'Create Account'}
        </button>
      </form>
    </div>
  );
}

export default AuthForm;
